<template>
  <div>
    <!-- 紧急件新增 -->
    <el-dialog :title="$t('message.urgentItemsAdded')" :close-on-click-modal="false" :visible.sync="dalogVisible"
      width="475px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 物流号 -->
          <el-form-item :label="$t('message.logisticsNumber') + ':'" prop="express_no">
            <el-input v-model="ruleForm.express_no"></el-input>
          </el-form-item>
          <!-- 类别选择 -->
          <el-form-item :label="$t('message.category') + ':'" prop="type">
            <el-select v-model="ruleForm.type" :placeholder="$t('message.categorySelection')" filterable clearable>
              <el-option v-for="item in urgentStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item :label="$t('message.remark') + ':'" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea" rows="4" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dalogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="urgentStore">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { urgentStatus } from "@/utlis/options";
export default {
  data() {
    return {
      urgentStatus,
      dalogVisible: false,
      ruleForm: {},
      rules: {
        express_no: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    dalogVisible() {
      if (this.dalogVisible) {
        this.ruleForm = {}
      }
    }
  },
  methods: {
    urgentStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.signInApi.urgentStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dalogVisible = false;
          });
        }
      });
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/.el-select {
  width: 100%
}
</style>